<template>
	<div class="container container-full-height container-bg-green">
		<span class="overlay" :class="{active: showLoginModal}"></span>
		<div class="header">
			<HeaderTitleWrap
				title="Create Your Profile"
				v-bind:subtitle="'Step ' + step + ' of 4'"
				icon="RegisterIcon"
			/>
		</div><!-- header -->
		<div class="content-wrap justify-space-between">
			<div v-if="step === 1" class="create-profile-content">
				<div class="text-block">
					<h1 class="title"><strong>{{ steps.stepOneTitle }}</strong></h1>
					<p class="no-space">{{ steps.stepOneText }}</p>
				</div>
				<Button @click.native="loginModalActive" icon="EmailIcon" class="btn-grey btn-med btn-icon btn-icon-left btn-email" text="Continue with Email"></Button>
			</div>
			<div v-if="step === 2" class="create-profile-content">
				<div class="text-block">
					<h1 class="title no-space"><strong>{{ steps.stepTwoTitle }}</strong></h1>
					<p class="no-space">{{ steps.stepTwoText }}</p>
				</div>
				<form class="form" @submit.prevent="">
					<div class="field" :class="{ 'field-error': $v.form.step2.fullName.$error || errorStyling == true }">
						<label for="full-name-input" class="label">Full Name</label>
						<div class="control">
							<input id="full-name-input" class="input" type="text" placeholder="Enter your full name" v-model="form.step2.fullName">
						</div>
					</div>
					<b-field label-for="gender" label="Gender (Optional)" :class="{ 'field-error': $v.form.step2.gender.$error || errorStyling == true }">
			            <b-select id="gender" placeholder="Please select" v-model="form.step2.gender">
							<option value="Male">Male</option>
							<option value="Female">Female</option>
                            <option value="Other">Other</option>
                            <option value="Prefer not to say">Prefer not to say</option>
			            </b-select>
			        </b-field>
			        <b-field label-for="age-range" label="Age Range (Optional)" :class="{ 'field-error': $v.form.step2.ageRange.$error || errorStyling == true }">
			            <b-select id="age-range" placeholder="Please select" v-model="form.step2.ageRange">
                            <option value="16-25">16-25</option>
                            <option value="26-35">26-35</option>
                            <option value="36-45">36-45</option>
                            <option value="46-55">46-55</option>
                            <option value="56-65">56-65</option>
                            <option value="65+">65+</option>
			            </b-select>
			        </b-field>
			        <b-field label-for="area" class="field-gap" label="Nationality (Optional)" :class="{ 'field-error': $v.form.step2.areaOfBirth.$error || errorStyling == true }">
			            <b-select id="area" placeholder="Please select" v-model="form.step2.areaOfBirth">
                            <option value="Albania" data-select2-id="74">Albania</option><option value="Algeria" data-select2-id="75">Algeria</option><option value="Antigua &amp; Barbuda" data-select2-id="76">Antigua &amp; Barbuda</option><option value="Argentina" data-select2-id="77">Argentina</option><option value="Australia" data-select2-id="78">Australia</option><option value="Bahamas" data-select2-id="79">Bahamas</option><option value="Bahrain" data-select2-id="80">Bahrain</option><option value="Bangladesh" data-select2-id="81">Bangladesh</option><option value="Barbados" data-select2-id="82">Barbados</option><option value="Belgium" data-select2-id="83">Belgium</option><option value="Belize" data-select2-id="84">Belize</option><option value="Bolivia" data-select2-id="85">Bolivia</option><option value="Brazil" data-select2-id="86">Brazil</option><option value="Bulgaria" data-select2-id="87">Bulgaria</option><option value="Canada" data-select2-id="88">Canada</option><option value="Chile" data-select2-id="89">Chile</option><option value="China" data-select2-id="90">China</option><option value="Colombia" data-select2-id="91">Colombia</option><option value="Comoros" data-select2-id="92">Comoros</option><option value="Cook Islands" data-select2-id="93">Cook Islands</option><option value="Costa Rica" data-select2-id="94">Costa Rica</option><option value="Cote d'Ivoire" data-select2-id="95">Cote d'Ivoire</option><option value="Croatia" data-select2-id="96">Croatia</option><option value="Cuba" data-select2-id="97">Cuba</option><option value="Cyprus" data-select2-id="98">Cyprus</option><option value="Dem. People's Rep. Korea" data-select2-id="99">Dem. People's Rep. Korea</option><option value="Dem. Rep. of the Congo" data-select2-id="100">Dem. Rep. of the Congo</option><option value="Denmark" data-select2-id="101">Denmark</option><option value="Dominica" data-select2-id="102">Dominica</option><option value="Egypt" data-select2-id="103">Egypt</option><option value="Estonia" data-select2-id="104">Estonia</option><option value="Faroe Islands" data-select2-id="105">Faroe Islands</option><option value="Finland" data-select2-id="106">Finland</option><option value="France" data-select2-id="107">France</option><option value="Georgia" data-select2-id="108">Georgia</option><option value="Germany" data-select2-id="109">Germany</option><option value="Ghana" data-select2-id="110">Ghana</option><option value="Greece" data-select2-id="111">Greece</option><option value="Honduras" data-select2-id="112">Honduras</option><option value="Hong Kong (China)" data-select2-id="113">Hong Kong (China)</option><option value="Iceland" data-select2-id="114">Iceland</option><option value="India" data-select2-id="115">India</option><option value="Indonesia" data-select2-id="116">Indonesia</option><option value="Iran" data-select2-id="117">Iran</option><option value="Ireland" data-select2-id="118">Ireland</option><option value="Israel" data-select2-id="119">Israel</option><option value="Italy" data-select2-id="120">Italy</option><option value="Jamaica" data-select2-id="121">Jamaica</option><option value="Japan" data-select2-id="122">Japan</option><option value="Jordan" data-select2-id="123">Jordan</option><option value="Kenya" data-select2-id="124">Kenya</option><option value="Kiribati" data-select2-id="125">Kiribati</option><option value="Kuwait" data-select2-id="126">Kuwait</option><option value="Latvia" data-select2-id="127">Latvia</option><option value="Lebanon" data-select2-id="128">Lebanon</option><option value="Liberia" data-select2-id="129">Liberia</option><option value="Libya" data-select2-id="130">Libya</option><option value="Lithuania" data-select2-id="131">Lithuania</option><option value="Luxembourg" data-select2-id="132">Luxembourg</option><option value="Malaysia" data-select2-id="133">Malaysia</option><option value="Malta" data-select2-id="134">Malta</option><option value="Marshall Islands" data-select2-id="135">Marshall Islands</option><option value="Mauritius" data-select2-id="136">Mauritius</option><option value="Mexico" data-select2-id="137">Mexico</option><option value="Mongolia" data-select2-id="138">Mongolia</option><option value="Morocco" data-select2-id="139">Morocco</option><option value="Myanmar" data-select2-id="140">Myanmar</option><option value="Netherlands" data-select2-id="141">Netherlands</option><option value="- Curacao" data-select2-id="142">- Curacao</option><option value="New Zealand" data-select2-id="143">New Zealand</option><option value="Nigeria" data-select2-id="144">Nigeria</option><option value="Norway" data-select2-id="145">Norway</option><option value="Pakistan" data-select2-id="146">Pakistan</option><option value="Palau" data-select2-id="147">Palau</option><option value="Panama" data-select2-id="148">Panama</option><option value="Papua New Guinea" data-select2-id="149">Papua New Guinea</option><option value="Philippines" data-select2-id="150">Philippines</option><option value="Poland" data-select2-id="151">Poland</option><option value="Portugal" data-select2-id="152">Portugal</option><option value="Qatar" data-select2-id="153">Qatar</option><option value="Republic of Korea" data-select2-id="154">Republic of Korea</option><option value="Republic of Moldova" data-select2-id="155">Republic of Moldova</option><option value="Romania" data-select2-id="156">Romania</option><option value="Russian Federation" data-select2-id="157">Russian Federation</option><option value="St. Kitts &amp; Nevis" data-select2-id="158">St. Kitts &amp; Nevis</option><option value="St. Vincent &amp; Grenadines" data-select2-id="159">St. Vincent &amp; Grenadines</option><option value="Sao Tome &amp; Principe" data-select2-id="160">Sao Tome &amp; Principe</option><option value="Saudi Arabia" data-select2-id="161">Saudi Arabia</option><option value="Sierra Leone" data-select2-id="162">Sierra Leone</option><option value="Singapore" data-select2-id="163">Singapore</option><option value="South Africa" data-select2-id="164">South Africa</option><option value="Spain" data-select2-id="165">Spain</option><option value="Sri Lanka" data-select2-id="166">Sri Lanka</option><option value="Sweden" data-select2-id="167">Sweden</option><option value="Switzerland" data-select2-id="168">Switzerland</option><option value="Syrian Arab Republic" data-select2-id="169">Syrian Arab Republic</option><option value="Tanzania" data-select2-id="170">Tanzania</option><option value="Thailand" data-select2-id="171">Thailand</option><option value="Togo" data-select2-id="172">Togo</option><option value="Tonga" data-select2-id="173">Tonga</option><option value="Trinidad &amp; Tobago" data-select2-id="174">Trinidad &amp; Tobago</option><option value="Tunisia" data-select2-id="175">Tunisia</option><option value="Turkey" data-select2-id="176">Turkey</option><option value="Tuvalu" data-select2-id="177">Tuvalu</option><option value="Ukraine" data-select2-id="178">Ukraine</option><option value="United Arab Emirates" data-select2-id="179">United Arab Emirates</option><option value="United Kingdom" data-select2-id="180">United Kingdom</option><option value="- Berrmuda" data-select2-id="181">- Berrmuda</option><option value="- British Virgin Islands" data-select2-id="182">- British Virgin Islands</option><option value="- Cayman Islands" data-select2-id="183">- Cayman Islands</option><option value="- Gibraltar" data-select2-id="184">- Gibraltar</option><option value="- Isle of Man" data-select2-id="185">- Isle of Man</option><option value="United States of America" data-select2-id="186">United States of America</option><option value="Uruguay" data-select2-id="187">Uruguay</option><option value="Vanuatu" data-select2-id="188">Vanuatu</option><option value="Venezuela" data-select2-id="189">Venezuela</option><option value="Viet Nam" data-select2-id="190">Viet Nam</option><option value="Other" data-select2-id="191">Other</option>
			            </b-select>
			        </b-field>
                    <b-field :class="{ 'field-error': $v.form.step2.type.$error || errorStyling == true }">
                        <b-checkbox v-model="form.step2.type">Is this account be for Seafarers Welfare, Corporate Partner, or Other?</b-checkbox>
                    </b-field>
					<div class="field error" v-if="errorMessage">
						<span class="field-error-message">{{ errorMessage }}</span>
					</div>
				</form>
			</div>
			<div v-if="step === 3" class="create-profile-content">
				<div class="text-block">
					<h1 class="title no-space"><strong>{{ steps.stepThreeTitle }}</strong></h1>
					<p class="no-space">{{ steps.stepThreeText }}</p>
				</div>
				<form class="form" @submit.prevent="">
					<b-field label-for="current-rank" label="Current Rank (Optional)" :class="{ 'field-error': $v.form.step3.currentRank.$error || errorStyling == true }">
			            <b-select id="current-rank" placeholder="Please select" v-model="form.step3.currentRank">
                            <option value="Captain">Captain</option>
                            <option value="Chief Engineer">Chief Engineer</option>
                            <option value="Chief Officer">Chief Officer</option>
                            <option value="Second Engineer">Second Engineer</option>
                            <option value="Second Officer">Second Officer</option>
                            <option value="Third Engineer">Third Engineer</option>
                            <option value="Third Officer">Third Officer</option>
                            <option value="Fourth Engineer">Fourth Engineer</option>
                            <option value="Catering Department">Catering Department</option>
                            <option value="Electrical Department">Electrical Department</option>
                            <option value="Deck Cadet">Deck Cadet</option>
                            <option value="Engine Cadet">Engine Cadet</option>
                            <option value="Deck Crew">Deck Crew</option>
                            <option value="Engine Crew">Engine Crew</option>
			            </b-select>
			        </b-field>
			        <b-field label-for="current-vessel" label="Current Vessel Type (Optional)" :class="{ 'field-error': $v.form.step3.currentVesselType.$error || errorStyling == true }">
			            <b-select id="current-vessel" placeholder="Please select" v-model="form.step3.currentVesselType">
                            <option value="Bulk Carrier">Bulk Carrier</option>
                            <option value="Cable Ship">Cable Ship</option>
                            <option value="Container Vessel">Container Vessel</option>
                            <option value="Cruise Ship">Cruise Ship</option>
                            <option value="Dredger">Dredger</option>
                            <option value="Ferry">Ferry</option>
                            <option value="General Cargo">General Cargo</option>
                            <option value="Offshore Vessel">Offshore Vessel</option>
                            <option value="Ro-Ro Vessel">Ro-Ro Vessel</option>
                            <option value="Superyacht">Superyacht</option>
                            <option value="Survey Vessel">Survey Vessel</option>
                            <option value="Tanker">Tanker</option>
			            </b-select>
			        </b-field>
                    <div class="field" :class="{ 'field-error': $v.form.step3.currentVesselName.$error || errorStyling == true }">
                        <label for="vessel-name-input" class="label">Current Vessel Name (Optional)</label>
                        <div class="control">
                            <input id="vessel-name-input" class="input" type="text" placeholder="Enter your current vessel name" v-model="form.step3.currentVesselName">
                        </div>
                    </div>
			        <b-field label-for="vessel-flag" label="Vessel Flag State (Optional)" :class="{ 'field-error': $v.form.step3.vesselFlagState.$error || errorStyling == true }">
			            <b-select id="vessel-flag" placeholder="Please select" v-model="form.step3.vesselFlagState">
                            <option value="Albania" data-select2-id="74">Albania</option><option value="Algeria" data-select2-id="75">Algeria</option><option value="Antigua &amp; Barbuda" data-select2-id="76">Antigua &amp; Barbuda</option><option value="Argentina" data-select2-id="77">Argentina</option><option value="Australia" data-select2-id="78">Australia</option><option value="Bahamas" data-select2-id="79">Bahamas</option><option value="Bahrain" data-select2-id="80">Bahrain</option><option value="Bangladesh" data-select2-id="81">Bangladesh</option><option value="Barbados" data-select2-id="82">Barbados</option><option value="Belgium" data-select2-id="83">Belgium</option><option value="Belize" data-select2-id="84">Belize</option><option value="Bolivia" data-select2-id="85">Bolivia</option><option value="Brazil" data-select2-id="86">Brazil</option><option value="Bulgaria" data-select2-id="87">Bulgaria</option><option value="Canada" data-select2-id="88">Canada</option><option value="Chile" data-select2-id="89">Chile</option><option value="China" data-select2-id="90">China</option><option value="Colombia" data-select2-id="91">Colombia</option><option value="Comoros" data-select2-id="92">Comoros</option><option value="Cook Islands" data-select2-id="93">Cook Islands</option><option value="Costa Rica" data-select2-id="94">Costa Rica</option><option value="Cote d'Ivoire" data-select2-id="95">Cote d'Ivoire</option><option value="Croatia" data-select2-id="96">Croatia</option><option value="Cuba" data-select2-id="97">Cuba</option><option value="Cyprus" data-select2-id="98">Cyprus</option><option value="Dem. People's Rep. Korea" data-select2-id="99">Dem. People's Rep. Korea</option><option value="Dem. Rep. of the Congo" data-select2-id="100">Dem. Rep. of the Congo</option><option value="Denmark" data-select2-id="101">Denmark</option><option value="Dominica" data-select2-id="102">Dominica</option><option value="Egypt" data-select2-id="103">Egypt</option><option value="Estonia" data-select2-id="104">Estonia</option><option value="Faroe Islands" data-select2-id="105">Faroe Islands</option><option value="Finland" data-select2-id="106">Finland</option><option value="France" data-select2-id="107">France</option><option value="Georgia" data-select2-id="108">Georgia</option><option value="Germany" data-select2-id="109">Germany</option><option value="Ghana" data-select2-id="110">Ghana</option><option value="Greece" data-select2-id="111">Greece</option><option value="Honduras" data-select2-id="112">Honduras</option><option value="Hong Kong (China)" data-select2-id="113">Hong Kong (China)</option><option value="Iceland" data-select2-id="114">Iceland</option><option value="India" data-select2-id="115">India</option><option value="Indonesia" data-select2-id="116">Indonesia</option><option value="Iran" data-select2-id="117">Iran</option><option value="Ireland" data-select2-id="118">Ireland</option><option value="Israel" data-select2-id="119">Israel</option><option value="Italy" data-select2-id="120">Italy</option><option value="Jamaica" data-select2-id="121">Jamaica</option><option value="Japan" data-select2-id="122">Japan</option><option value="Jordan" data-select2-id="123">Jordan</option><option value="Kenya" data-select2-id="124">Kenya</option><option value="Kiribati" data-select2-id="125">Kiribati</option><option value="Kuwait" data-select2-id="126">Kuwait</option><option value="Latvia" data-select2-id="127">Latvia</option><option value="Lebanon" data-select2-id="128">Lebanon</option><option value="Liberia" data-select2-id="129">Liberia</option><option value="Libya" data-select2-id="130">Libya</option><option value="Lithuania" data-select2-id="131">Lithuania</option><option value="Luxembourg" data-select2-id="132">Luxembourg</option><option value="Malaysia" data-select2-id="133">Malaysia</option><option value="Malta" data-select2-id="134">Malta</option><option value="Marshall Islands" data-select2-id="135">Marshall Islands</option><option value="Mauritius" data-select2-id="136">Mauritius</option><option value="Mexico" data-select2-id="137">Mexico</option><option value="Mongolia" data-select2-id="138">Mongolia</option><option value="Morocco" data-select2-id="139">Morocco</option><option value="Myanmar" data-select2-id="140">Myanmar</option><option value="Netherlands" data-select2-id="141">Netherlands</option><option value="- Curacao" data-select2-id="142">- Curacao</option><option value="New Zealand" data-select2-id="143">New Zealand</option><option value="Nigeria" data-select2-id="144">Nigeria</option><option value="Norway" data-select2-id="145">Norway</option><option value="Pakistan" data-select2-id="146">Pakistan</option><option value="Palau" data-select2-id="147">Palau</option><option value="Panama" data-select2-id="148">Panama</option><option value="Papua New Guinea" data-select2-id="149">Papua New Guinea</option><option value="Philippines" data-select2-id="150">Philippines</option><option value="Poland" data-select2-id="151">Poland</option><option value="Portugal" data-select2-id="152">Portugal</option><option value="Qatar" data-select2-id="153">Qatar</option><option value="Republic of Korea" data-select2-id="154">Republic of Korea</option><option value="Republic of Moldova" data-select2-id="155">Republic of Moldova</option><option value="Romania" data-select2-id="156">Romania</option><option value="Russian Federation" data-select2-id="157">Russian Federation</option><option value="St. Kitts &amp; Nevis" data-select2-id="158">St. Kitts &amp; Nevis</option><option value="St. Vincent &amp; Grenadines" data-select2-id="159">St. Vincent &amp; Grenadines</option><option value="Sao Tome &amp; Principe" data-select2-id="160">Sao Tome &amp; Principe</option><option value="Saudi Arabia" data-select2-id="161">Saudi Arabia</option><option value="Sierra Leone" data-select2-id="162">Sierra Leone</option><option value="Singapore" data-select2-id="163">Singapore</option><option value="South Africa" data-select2-id="164">South Africa</option><option value="Spain" data-select2-id="165">Spain</option><option value="Sri Lanka" data-select2-id="166">Sri Lanka</option><option value="Sweden" data-select2-id="167">Sweden</option><option value="Switzerland" data-select2-id="168">Switzerland</option><option value="Syrian Arab Republic" data-select2-id="169">Syrian Arab Republic</option><option value="Tanzania" data-select2-id="170">Tanzania</option><option value="Thailand" data-select2-id="171">Thailand</option><option value="Togo" data-select2-id="172">Togo</option><option value="Tonga" data-select2-id="173">Tonga</option><option value="Trinidad &amp; Tobago" data-select2-id="174">Trinidad &amp; Tobago</option><option value="Tunisia" data-select2-id="175">Tunisia</option><option value="Turkey" data-select2-id="176">Turkey</option><option value="Tuvalu" data-select2-id="177">Tuvalu</option><option value="Ukraine" data-select2-id="178">Ukraine</option><option value="United Arab Emirates" data-select2-id="179">United Arab Emirates</option><option value="United Kingdom" data-select2-id="180">United Kingdom</option><option value="- Berrmuda" data-select2-id="181">- Berrmuda</option><option value="- British Virgin Islands" data-select2-id="182">- British Virgin Islands</option><option value="- Cayman Islands" data-select2-id="183">- Cayman Islands</option><option value="- Gibraltar" data-select2-id="184">- Gibraltar</option><option value="- Isle of Man" data-select2-id="185">- Isle of Man</option><option value="United States of America" data-select2-id="186">United States of America</option><option value="Uruguay" data-select2-id="187">Uruguay</option><option value="Vanuatu" data-select2-id="188">Vanuatu</option><option value="Venezuela" data-select2-id="189">Venezuela</option><option value="Viet Nam" data-select2-id="190">Viet Nam</option><option value="Other" data-select2-id="191">Other</option>
			            </b-select>
			        </b-field>
			        <b-field label-for="service-length" class="field-gap" label="Length of Service (Optional)" :class="{ 'field-error': $v.form.step3.lengthOfService.$error || errorStyling == true }">
			            <b-select id="service-length" placeholder="Please select" v-model="form.step3.lengthOfService">
                            <option value="1-3 months">1-3 months</option>
                            <option value="4-6 months">4-6 months</option>
                            <option value="7-9 months">7-9 months</option>
                            <option value="10-12 months">10-12 months</option>
                            <option value="Over 12 months">Over 12 months</option>
			            </b-select>
			        </b-field>
					<div class="field error" v-if="errorMessage">
						<span class="field-error-message">Incorrect email address or password.</span>
					</div>
				</form>
			</div>
			<div v-if="step === 4" class="create-profile-content">
				<div class="text-block">
					<h1 class="title no-space"><strong>{{ steps.stepFourTitle }}</strong></h1>
					<p class="no-space">{{ steps.stepFourText }}</p>
				</div>
				<form class="form" @submit.prevent="">
					<b-field :class="{ 'field-error': $v.form.step4.privacy.$error || errorStyling == true }">
			            <b-checkbox v-model="form.step4.privacy">I agree to the <a style="color: #23C86A; text-decoration: underline;" target="_blank" href="https://www.missiontoseafarers.org/privacy-policy">privacy statement</a>.</b-checkbox>
			        </b-field>
					<div class="field error" v-if="$v.form.step4.privacy.$error">
						<span style="display: inline-block;" class="field-error-message">You need to agree to our privacy statement in order to create your profile.</span>
					</div>
				</form>
			</div>
			<div v-if="step === 1" class="flex-bottom">
				<a @click="$router.push({ name: 'Dashboard' })" class="text-link text-link-grey">I'll create a profile another time &raquo;</a>
			</div><!-- flex bottom -->
			<div v-if="step === 2" class="flex-bottom">
				<Button @click.native="step2" class="btn-large btn-green" text="Continue"></Button>
				<a @click.prevent="completeAnotherTime" class="text-link text-link-grey">&laquo; Complete your profile another time</a>
                <!-- Log Out? -->
			</div><!-- flex bottom -->
			<div v-if="step === 3" class="flex-bottom">
				<Button @click.native="step3" class="btn-large btn-green" text="Continue"></Button>
				<a @click.prevent="goBack" class="text-link text-link-grey">&laquo; Return to Step 2</a>
			</div><!-- flex bottom -->
			<div v-if="step === 4" class="flex-bottom">
				<Button @click.native="createProfile" class="btn-large btn-green" text="Complete My Profile"></Button>
				<a @click.prevent="goBack" class="text-link text-link-grey">&laquo; Return to Step 3</a>
			</div><!-- flex bottom -->
		</div><!-- content wrap -->
		<div v-if="step === 1"  ref="modalEmail" class="phone-modal modal-email" :style="{ bottom: modalLoginHeight + 'px'}" :class="{active: showLoginModal}">
			<span class="modal-line"></span>
			<div class="modal-title-bar">
				<div class="icon-wrap">
					<EmailIcon style="width: 31px; height: 31px;" class="icon email-icon" />
					<span>Continue with my Email Address</span>
				</div><!-- icon wrap -->
				<GreyCloseIcon @click="loginModalActive" style="width: 31px; height: 31px;" class="icon close" />
			</div><!-- modal title bar -->
			<form style="padding-top: 10px;" class="form" @submit.prevent>
				<div class="field field-icon" :class="{ 'field-error': $v.form.step1.email.$error || errorStyling == true }">
					<label for="email-input" class="label">Email Address</label>
					<div class="control">
						<input id="email-input" class="input" type="email" placeholder="Enter your email address" v-model="form.step1.email" enterkeyhint="next" inputmode="email" @keyup.enter="$refs.password_input.focus()" @keydown.enter.prevent>
						<EmailIcon style="width: 21px; height: 22px;" class="icon icon-email" />
					</div>
				</div>
				<div class="field field-icon" :class="{ 'field-error':$v.form.step1.password.$error || errorStyling == true }">
					<label for="password-input" class="label">Password</label>
					<div class="control">
						<input id="password-input" ref="password_input" class="input" type="password" placeholder="Enter your password" v-model="form.step1.password" enterkeyhint="next" @keyup.enter="$refs.repeat_password_input.focus()" @keydown.enter.prevent>
						<KeyIcon style="width: 20px; height: 21px;" class="icon icon-key" />
					</div>
				</div>
				<div class="field field-gap field-icon" :class="{ 'field-error':$v.form.step1.passwordRepeat.$error || errorStyling == true }">
					<label for="password-input-repeat" class="label">Repeat Password</label>
					<div class="control">
						<input id="password-input-repeat" ref="repeat_password_input" class="input" type="password" placeholder="Retype your password" v-model="form.step1.passwordRepeat" enterkeyhint="done" @keyup.native.enter="step1">
						<KeyIcon style="width: 20px; height: 21px;" class="icon icon-key" />
					</div>
				</div>
				<div class="field error" v-if="errorMessage">
                    <span v-if="errorMessageText" class="field-error-message">{{ errorMessageText }}</span>
                    <span v-else class="field-error-message">Incorrect email address or password.</span>
				</div>
				<Button @click.native="step1" icon="ArrowRightIcon" class="btn-med btn-green btn-icon btn-icon-right btn-arrow" text="Continue with my Email Address"></Button>
			</form>
			<a @click="loginModalActive" class="text-link text-link-grey">I don't want to use with my email address &raquo;</a>
		</div><!-- modal -->
	</div>
</template>
<script>
	import Button from '@/components/Button.vue';
	import HeaderTitleWrap from '@/components/HeaderTitleWrap.vue';
	import { required, sameAs } from 'vuelidate/lib/validators';
	import GreyCloseIcon from '@/assets/close-grey.svg';
	import EmailIcon from '@/assets/email.svg';
	import KeyIcon from '@/assets/key.svg';
	// import ArrowDropdown from '@/assets/arrow-dropdown.svg';
	// import SendIcon from '@/assets/send.svg';
    import AuthService from '@/services/AuthService';
    import UserService from '@/services/UserService';
    import { Capacitor } from '@capacitor/core';
    import { Keyboard, KeyboardResize } from '@capacitor/keyboard';
    // import { SignInWithApple, SignInWithAppleResponse, SignInWithAppleOptions } from '@capacitor-community/apple-sign-in';

    export default {
		name: 'CreateProfileGetStarted',
		components: {
	    	HeaderTitleWrap,
	    	Button,
	    	GreyCloseIcon,
			KeyIcon,
			EmailIcon
			// ArrowDropdown
		},
		data () {
	        return {
	        	step: 1,
	        	steps: {
	        		stepOneTitle: 'How would you like to login?',
	            	// stepOneText: 'You can choose to sign up via email or through your favourite social media service',
                    stepOneText: 'You can choose to sign up via email, with social media providers coming soon...',
	            	stepTwoTitle: 'Tell us a little about you...',
	            	stepTwoText: 'By filling more information about you, we can tailor your experience within the app. This will mean you see more relevant content, and are asked less information as you use it.',
	            	stepThreeTitle: 'And finally, tell us a little about your career...',
	            	stepThreeText: 'Providing us with this information will allow us to help you quicker',
	            	stepFourTitle: 'Our Privacy Statement',
	            	stepFourText: 'Read our privacy statement via The Mission to Seafarers website by clicking the link below.'
	        	},
	            modalLogin: null,
				modalLoginHeight: null,
				showModal: false,
				showLoginModal: false,
				form: {
					step1: {
	        			email: null,
						password: null,
						passwordRepeat: null
	        		},
					step2: {
						fullName: null,
						gender: null,
						ageRange: null,
						areaOfBirth: null,
                        type: null
					},
					step3: {
						currentRank: null,
						currentVesselType: null,
						vesselFlagState: null,
						lengthOfService: null,
                        currentVesselName: null
					},
					step4: {
						privacy: null
					}
				},
				errorMessage: null,
                errorMessageText: null,
				blankPassword: null,
				errorStyling: null,
                appleResponse: null
	        };
	    },
	    validations () {
			if (this.step === 1) {
	            return {
	                form: {
	                    step1: {
		            		email: {
								required
							},
							password: {
								required
							},
							passwordRepeat: {
								required
							}
		            	}
	                }
	            };
	        }
	        if (this.step === 2) {
	            return {
	                form: {
	                    step2: {
							fullName: {
								required
							},
							gender: {},
							ageRange: {},
							areaOfBirth: {},
                            type: {}
		                }
	                }
	            };
	        }
	        if (this.step === 3) {
	            return {
	                form: {
	                    step3: {
							currentRank: {},
							currentVesselType: {},
                            currentVesselName: {},
							vesselFlagState: {},
							lengthOfService: {}
		                }
	                }
	            };
	        }
	        if (this.step === 4) {
	            return {
	                form: {
	                    step4: {
							privacy: {
								sameAs: sameAs(() => true)
							}
		                }
	                }
	            };
	        }
		},
		computed: {
			matchHeightModalEmail () {
				return '-' + this.$refs.modalEmail.clientHeight;
			},
            isAuthenticated () {
                return this.$store.getters.isAuthenticated;
            }
		},
        watch: {
            step () {
                if (this.isAuthenticated && this.step === 1) {
                    this.step++;
                }
                if (Capacitor.isNativePlatform()) {
                    Keyboard.setResizeMode({
                        mode: this.step === 1 ? KeyboardResize.None : KeyboardResize.Native
                    });
                }
            }
        },
		methods: {
			goBack () {
	            this.step--;
                if (this.form.step2.type) {
                    this.step--;
                }
	        },
		    loginModalActive () {
		    	this.modalLoginHeight = '-' + this.$refs.modalEmail.clientHeight;
		    	this.showLoginModal = !this.showLoginModal;
		    },
		    async step1 () {
		    	var self = this;
		  		this.$v.form.step1.$touch();
	            if (!this.$v.form.step1.$error) {
                    try {
                        await AuthService.register({
                            email: this.form.step1.email,
                            password: this.form.step1.password,
                            password_confirmation: this.form.step1.passwordRepeat
                        }).then(() => {
                            this.errorMessage = false;
                            this.errorStyling = false;
                            this.errorMessageText = null;
                            this.loginModalActive();
                            setTimeout(function () {
                                self.step++;
                            }, 500);
                        });
                    } catch (error) {
                        this.errorMessage = true;
                        this.errorStyling = true;
                        if (error.response && error.response.data && error.response.data.message) {
                            this.errorMessageText = error.response.data.message;
                        }
                    }
	            }
		    },
		    step2 () {
		  		this.$v.form.step2.$touch();
	            if (!this.$v.form.step2.$error) {
	                this.step++;
                    if (this.form.step2.type) {
                        this.step++;
                    }
	            }
		    },
		    step3 () {
		  		this.$v.form.step3.$touch();
	            if (!this.$v.form.step3.$error) {
	                this.step++;
	            }
		    },
		    createProfile () {
		    	var self = this;
		    	this.$v.form.step4.$touch();
	            if (!this.$v.form.step4.$error) {
                    try {
                        UserService.createProfile({
                            name: this.form.step2.fullName,
                            gender: this.form.step2.gender,
                            age_range: this.form.step2.ageRange,
                            area_of_birth: this.form.step2.areaOfBirth,
                            rank: this.form.step3.currentRank,
                            vessel_type: this.form.step3.currentVesselType,
                            vessel_name: this.form.step3.currentVesselName,
                            vessel_flag_state: this.form.step3.vesselFlagState,
                            length_of_service: this.form.step3.lengthOfService,
                            privacy_agreement: this.form.step4.privacy ? 1 : 0
                        }).then(() => {
                            this.$router.push({ name: 'Dashboard', params: { isProfileModalOpen: true } });
                        });
                    } catch (error) {
                        console.log(error);
                        this.errorMessage = true;
                        this.errorStyling = true;
                    }
	            }
		    },
            logout () {
                if (this.$store.getters.isAuthenticated) {
                    UserService.logout();
                }
            },
            oauth (provider) {
                return `${process.env.VUE_APP_API_URL}/auth/${provider}`;
            },
            getDashboard () {
                UserService.getDashboard().then((response) => {
                    this.$store.state.hasProfile = response.data.profile;
                    if (response.data && response.data.apple_name) {
                        this.form.step2.fullName = response.data.apple_name;
                    }
                    if (this.$store.state.hasProfile) {
                        this.$router.push({ name: 'Dashboard' });
                    }
                });
            },
            // async apple () {
            //     let token;
            //     let name;
            //     await SignInWithApple.authorize({
            //         clientId: 'org.missiontoseafarers.app',
            //         redirectURI: process.env.VUE_APP_URL,
            //         scopes: 'email name'
            //     }).then((response) => {
            //         token = response.response.identityToken;
            //         name = response.response.givenName + ' ' + response.response.familyName;
            //     }).catch((error) => {
            //         console.log(error);
            //     });
            //     if (token) {
            //         AuthService.apple({
            //             token: token,
            //             name: name
            //         }).then(() => {
            //             this.getDashboard();
            //             setTimeout(() => {
            //                 this.step++;
            //             }, 500);
            //         }).catch((error) => {
            //             console.log(error);
            //         });
            //     }
            // },
            completeAnotherTime () {
                this.logout();
                this.$router.push('/dashboard');
            }
		},
		mounted () {
			this.modalLoginHeight = this.matchHeightModalEmail;
            UserService.getUser().then((response) => {
                if (response.status === 200) {
                    this.step++;
                    if (response.data && response.data.apple_name) {
                        this.form.step2.fullName = response.data.apple_name;
                    }
                }
            });
            if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
                Keyboard.setAccessoryBarVisible({
                    isVisible: true
                });
                Keyboard.addListener('keyboardWillShow', (info) => {
                    this.$refs.modalEmail.style.marginBottom = `${info.keyboardHeight}px`;
                });
                Keyboard.addListener('keyboardWillHide', () => {
                    this.$refs.modalEmail.style.marginBottom = '0';
                });
            }
		}
	};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/_global.scss";
form {
	display: flex;
    flex: auto;
    flex-direction: column;
    justify-content: space-between;
}
.text-link {
	font-size: 14px;
	color: $light;
	letter-spacing: -0.35px;
	display: inline-block;
	margin-top: 8px;
	&.text-link-grey {
		color: $mid;
	}
}
.p-statement {
	margin-top: 20px;
}
.checkbox input {
    margin-right: 10px;
}
</style>
